<script>
export default {
  functional: true,
  name: 'GridContainer',
  props: {
    col: {
      type: Number,
      default: 3,
    },
    rows: {
      type: Number,
    },
  },
  render (h, ctx) {
    const { props, children, data } = ctx;
    return h('ul', {
      ...data,
      style: {
        gridTemplateColumns: `${Array(props.col).fill('1fr').join(' ')}`,
        gridTemplateRows: props.rows && `${Array(props.rows).fill('1fr').join(' ')}`,
      },
      class: ['grid-container'],
    }, children.map(slot => h('li', {
      class: ['griditem'],
    }, [slot])));
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.grid-container {
  display: grid;
  /* grid-template-columns: 1fr 1fr 1fr 1fr; */
  grid-column-gap: var(--gridGap);
  grid-row-gap: var(--gridGap);
}

</style>
